
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PackageViewComponent } from './package-view/package-view.component';


const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Package Master',
          },
        component: PackageViewComponent,
    }
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PackageRoutingModule { }